<template>
    <div class="contact_form">
        <v-container>
         <v-row>
         <v-col
        :cols="12"
        :sm="12"
        :md="8"
        class="order-md-0 order-1"
        >
         <v-form v-model="valid"  >
          <v-row>
           <v-col
           :cols="12"
           :sm="12"
           :md="12"
           >
              <div>
                <v-textarea :label="$t('formes.labels.contactUs.message')"  hide-details="auto"
                :counter="200" :outlined="true"
                required
                ></v-textarea>
            </div>
           </v-col>
            <v-col
           :cols="12"
           :sm="6"
           :md="6"
           >
              <div>
                <v-text-field :label="$t('formes.labels.contactUs.name')" :outlined="true"  hide-details="auto"
                :counter="20" required
                ></v-text-field>
            </div>
           </v-col>
            <v-col
           :cols="12"
           :sm="6"
           :md="6"
           >
              <div>
                <v-text-field :label="$t('formes.labels.contactUs.email')" type="email" :outlined="true"  hide-details="auto"
                :counter="20" required
                ></v-text-field>
            </div>
           </v-col>
            <v-col
           :cols="12"
           :sm="12"
           :md="12"
           >
              <div>
                <v-text-field :label="$t('formes.labels.contactUs.subject')" :outlined="true"  hide-details="auto"
                :counter="20" required
                ></v-text-field>
            </div>
           </v-col>
           
          </v-row>
          <v-btn dark block type="submit" class="mx-auto" color="red">{{$t("contactUs.sent")}}</v-btn>
          </v-form>
          </v-col>
          <v-col
           :cols="12"
            :sm="12"
            :md="4"
            class="order-0 order-md-1"
          >
          <div class="contact-info mt-6 mb-6 d-flex align-baseline">
           <i class="fa fa-bank fa-2x mt-auto mb-auto ml-4 mr-4"></i>
           <div>
           <h3>Buttonwood, California.</h3>
           <p class="mb-0" style="font-size: 11pt;">{{$t("contactUs.conatactMethod.visite")}}</p>
           </div>
           </div>
           <div class="contact-info d-flex mt-6 mb-6 align-baseline">
            <i class="fa fa-phone fa-2x mt-auto mb-auto ml-4 mr-4"></i>
           <div>
           <h3>+1265489874</h3>
           <p class="mb-0" style="font-size: 11pt;">{{$t("contactUs.conatactMethod.call")}}</p>
           </div>
           </div>
           <div class="contact-info d-flex mt-6 mb-6 align-baseline">
           <i class="fa fa-whatsapp fa-2x mt-auto mb-auto ml-4 mr-4"></i>
            <div>
            <h3>+7236468098</h3>
            <p class="mb-0" style="font-size: 11pt;">{{$t("contactUs.conatactMethod.wattsup")}}</p>
            </div>
            </div>
           <div class="contact-info d-flex mt-6 mb-6 align-baseline">
           <a href="#" class="black--text text-decoration-none mt-auto mb-auto">
           <i class="fa fa-facebook-f fa-2x mt-auto mb-auto ml-4 mr-4"></i>
           </a>
           <div>
           <h3><a href="#" class="black--text text-decoration-none">Resto page name</a></h3>
           <p class="mb-0" style="font-size: 11pt;">{{$t("contactUs.conatactMethod.facebook")}}</p>
           </div>
          </div>
          </v-col>
          </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name:'contact_form',
    data() {
        return {
            valid:false
        }
    },
}
</script>